export default class BaseRunningTextTheme {

  name = null;
  setting = {};

  constructor(name) {
    this.name = name
  }

  name() {
    return this.name;
  }
  widgetClass() {
    return 'tr-running-text';
  }
  themeClass() {
    return `theme-${this.name}`;
  }

  dependencies() {
    return {
      'js': [],
      'css': []
    };
  }
  htmlContainer() {
    let exclusiveTheme = ['ramadhan']
    if (exclusiveTheme.includes(this.name)) {
      //execute exclusive container
      if (typeof this.exclusiveHtmlContainer === "function") {
        return this.exclusiveHtmlContainer()
      }
    } else {
      return `<div class="${this.widgetClass()} ${this.themeClass()} container" id="marquee"></div>`;
    }
  }

  // font() {}
  // styles() {}
  // html() {}
  // htmlTemplateWhenEmpty(data) {}
  // async setData(elem, data) {}

  async setup(setting) {
    this.setting = setting;
  }

  pushItem(elem) {
    const elList = h.el(`.${this.themeClass()}#marquee`);
    elList.appendChild(elem);
  }
  fnExtraMessageOnHead() {
    var $placeholder = document.createElement('div');
    $placeholder.innerHTML = (this.setting['rt_interval'] == 1) 
      ? 'Top Supporter Hari Ini' 
      : 'Top Supporter ' + this.setting['rt_interval'] + ' Hari Terakhir';
    return $placeholder;
  };

  fnExtraMessageOnTail(name, url) {
    let rt_messages = this.setting['rt_messages'] || 'Ayo traktir {username} di {trlink} dukung menggunakan Gopay, OVO, Dana, LinkAja, Shopeepay, QRIS, dan Transfer Bank';
    var $placeholder = document.createElement('div');
    rt_messages = rt_messages.replace('{username}', name);
    rt_messages = rt_messages.replace('{trlink}', '<strong class="highlight" style="margin-left: 10px; margin-right: 10px">' + url + '</strong>');
    $placeholder.innerHTML = rt_messages;
    return $placeholder;
  };

  async setData(elem, data) {
    var aliases = '';
    
    if(this.setting['rt_type'] == 'top-supporters') {
      aliases = data.supporter.supporter_name.split('_!!!_');

      h.setTextContent(h.el('.no', elem), '( ' + data.no + ' )' );
      h.setTextContent(h.el('.sum', elem), data.supporter.sum || 1);
    } else {
      aliases = data.supporter.display_name.split('_!!!_');
      var message = '';
      if (h.isTrue(this.setting['rt_showsuppmsg'])) {
        if(data.supporter.support_message) {
          message = data.supporter.support_message.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
            return '&#'+i.charCodeAt(0)+';';
          });
          message = ', "' + message + '"'
        }
      }

      // let msg = (data.supporter.support_message !== null && h.isTrue(this.setting['rt_showsuppmsg'])) ? `, "`+data.supporter.support_message+`"` : ''
      h.setTextContent(h.el('.supporter-message', elem), message );
      h.setTextContent(h.el('.sum', elem), data.supporter.quantity || 1);
    }

    var currentAlias = aliases[aliases.length - 1] || 'Seseorang';
    h.setTextContent(h.el('.highlight', elem), h.escapeHtml(currentAlias.replace("`", "\`")));
    h.setTextContent(h.el('.unit-name', elem), data.unitName || '');

    if(this.setting['rt_theme'] == 'default') {
      h.setHTML(h.el('.unit-icon', elem), data.icon);
    }
  }

}